import React from 'react';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';
/**
 *
 * @param {*} param0
 * @returns {수정 인풋 감싸는 gray container }
 */
type IProps = {
  children: JSX.Element[] | JSX.Element;
  layout?: boolean; // 유무로 width 값이 조정된다.
  style?: React.CSSProperties;
  left?: string | undefined; // 왼쪽에 있는 박스에 margin-right 값을 준다.
  fullSize?: string | undefined; // 왼쪽에 있는 박스에 margin-right 값을 준다.
  className?: string | undefined; // 스클
  width?: string | undefined;
  onChange?: () => void;
};
const GrayBox: React.FC<IProps> = ({
  width,
  children,
  style,
  layout,
  left,
  fullSize,
  className,
}) => {
  return (
    <Container
      style={style}
      layout={layout}
      left={left}
      fullSize={fullSize}
      className={`gray_box ${className}`}
      width={width}
    >
      {children}
    </Container>
  );
};
export default GrayBox;
const Container = styled.div`
  overflow: auto;
  background-color: ${theme.colors.gray_1};
  box-shadow: 1px 2px 3px 1px rgba(0, 0, 0, 0.1);
  padding: 1rem 2rem;
  width: ${(props) =>
    props.layout ? 'unset' : props.width ? props.width : '55rem'};
  border-radius: 0.5rem;
  margin-bottom: 1rem;
  /* 스크롤바 전체 */
  &::-webkit-scrollbar {
    width: 0.5rem;
  }
  /* 스크롤 막대 */
  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.1);
  }
  /* 스크롤 막대 외부 */
  &::-webkit-scrollbar-track {
    width: 0.6rem;
    /* background-color: red; */
  }
  &:first-child,
  &.scroll_box {
    /* border: solid 2px blue; */
    max-height: 46.5rem;
    height: ${(props) => (props.fullSize ? '46.5rem' : '100%')};
    margin-right: ${(props) => (props.left ? '1.5rem' : '')};
  }
  &.scroll_box {
    width: 50%;
  }
  th {
    vertical-align: baseline;
  }
  /* antd datepicker 보더값 없애기 */
  .ant-picker-range {
    border: none;
  }
  /* .checkbox_container {
    display: flex;
    width: 100%;
    .ant-checkbox-group {
      width: 100%;
      display: flex;
      justify-content: space-between;
    }
  } */
  .checkbox_container {
    display: flex;
    justify-content: space-between;
    > div {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }

  .one_row_multi_column {
    display: flex;
    margin-bottom: 2rem;
  }

  .sales_multi_column {
    display: flex;
    padding: 0;
    padding-bottom: 0;
    tr {
      display: flex;
      flex-direction: column;
      margin: 0 0.5rem;
    }
    td {
      padding: 0;
    }
    th {
      text-align: left;
      /* width: 6rem; */
      padding: 0;
    }
    .opacity0 {
      padding-top: 0;
      border: solid 2px blue;
      opacity: 0;
      height: 0;
    }
  }

  .currency_sprite {
    color: ${theme.colors.blueText};
    font-weight: 600;
  }
  .currency_ability,
  .checkbox_container {
    display: flex;
    justify-content: space-between;
    margin-bottom: 1rem;
    > div {
      width: 10rem;
    }
    .bt_wrap {
      display: flex;
      align-items: flex-end;
      justify-content: flex-start;
      transform: translate(-4rem, 0);
    }
    p {
      color: ${theme.colors.blueText};
      font-weight: 600;
    }
  }
  .title {
    font-size: 1rem;
    color: ${theme.colors.blueText};
    font-weight: 700;
  }
  /* p {
    color: ${theme.colors.blueText};
    font-weight: 600;
  } */
  .description {
    font-weight: 300;
    font-size: 0.8rem;
    color: ${theme.colors.gray_2};
  }

  /* 등급제 */
  .grade {
    /* border: solid 2px blue; */
    tr {
      /* border: solid 2px blue; */
      margin: 0 0.5rem;
    }
  }

  .intro {
    > div {
      display: flex;
      overflow: visible;
      th,
      td {
        padding: 0;
        padding-right: 0.5rem;
      }
      tr {
        /* border: solid 2px blue; */
        /* width: 22rem; */
        &:last-child {
          .ant-select {
            width: 10rem;
          }
        }
      }
      th {
        width: 10rem;
      }
      td {
        width: 13.5rem;
      }
      tr {
        margin-right: 1rem;
      }
      .title {
        width: 5rem;
      }
      .ant-input-affix-wrapper-borderless {
        width: 15rem;
      }
      .message {
        background: #f0f0f0;
        padding: 0.25rem 0.75rem;
      }
      .message2 {
        height: 2.25rem;
        padding: 0.3rem 0.75em;
      }
    }
  }
  .ifyou_pass {
    display: flex;
    .title {
      width: 15rem !important;
    }
    /* transform: translate(0, 0.5rem); */
    .ifyou_p {
      width: 10rem;
      margin-bottom: 2rem;
      transform: translate(0rem, 1rem);
      text-align: right;
      padding-right: 1.2rem;
      color: ${(props) => props.theme.colors.blueText};
      font-weight: 600;
    }
    .flex {
      height: 10rem;
      transform: translate(0, 1rem);
      tr {
        /* margin: 2rem 0; */
        th {
          /* vertical-align: top; */
        }
      }
    }
    .content_wrap {
      transform: translate(0rem, 0.2rem);
    }
  }
`;
